const PLACEHOLDER_KEYS = [
    'customer_firstname',
    'customer_lastname',
    'customer_name',
    'customer_phone',
    'order_id',
    'partner_title',
    'chat_title'
];

let cachedItems = null;
let cachePromise = null;

const toText = value => {
    if (value === null || value === undefined) {
        return '';
    }
    return String(value).trim();
};

export const clearChatQuickReplyCache = () => {
    cachedItems = null;
    cachePromise = null;
};

export const getChatQuickReplies = async (axios) => {
    if (cachedItems) {
        return cachedItems;
    }

    if (!cachePromise) {
        cachePromise = axios.get('/chat-quick-replies')
            .then(({ data }) => data || [])
            .finally(() => {
                cachePromise = null;
            });
    }

    cachedItems = await cachePromise;
    return cachedItems;
};

export const buildQuickReplyContext = ({
    customer = {},
    chat = {},
    order = {}
} = {}) => {
    const firstname = toText(customer.firstname);
    const lastname = toText(customer.lastname);
    const customerName = [firstname, lastname].filter(Boolean).join(' ');
    const orderId = order.id || chat.order_id || '';
    const partnerTitle = toText(order.partner?.title || order.partner_title);

    return {
        customer_firstname: firstname,
        customer_lastname: lastname,
        customer_name: customerName,
        customer_phone: toText(customer.phone),
        order_id: toText(orderId),
        partner_title: partnerTitle,
        chat_title: toText(chat.title)
    };
};

export const applyQuickReplyPlaceholders = (body, context = {}) => {
    const source = String(body || '');
    const values = { ...context };

    PLACEHOLDER_KEYS.forEach(key => {
        if (values[key] === undefined || values[key] === null) {
            values[key] = '';
        } else {
            values[key] = String(values[key]);
        }
    });

    return source.replace(/\{\{\s*([a-z_]+)\s*\}\}/gi, (match, key) => {
        const normalized = String(key || '').toLowerCase();
        if (!Object.prototype.hasOwnProperty.call(values, normalized)) {
            return '';
        }
        return values[normalized];
    });
};

export default {
    applyQuickReplyPlaceholders,
    buildQuickReplyContext,
    clearChatQuickReplyCache,
    getChatQuickReplies
};
